import React from 'react';
import styles from './Header.css';

const Title = ({ dataTestId, title }: { dataTestId: string; title: string }) => {
    return (
        <div data-testid={dataTestId} className={styles.title}>
            {title}
        </div>
    );
};

export default React.memo(Title);
